import cn from 'classnames'
import Pill from 'ext-ui/components/Pill/Pill'
import React, { ComponentProps, ReactElement } from 'react'
import LoadingShimmer from 'src/components/LoadingShimmer/LoadingShimmer'

import style from './Tab.style'

export type TabProps = {
  className?: string
  active?: boolean
  countLoading?: boolean
  count?: number
  variant?: 'default' | 'severe'
} & ComponentProps<'div'>

function Tab(props: TabProps): ReactElement {
  const {
    className = '',
    variant = 'default',
    active,
    countLoading,
    count,
    children,
    ...rest
  } = props

  return (
    <div
      className={cn('Tab', className, variant, { active })}
      css={style}
      {...rest}
    >
      {children}
      {countLoading !== undefined && countLoading && (
        // show loading state only if it is explicitly set
        <LoadingShimmer width={'16px'} height={'18px'} />
      )}
      {count !== undefined && (
        <Pill
          className={cn('Tab-count')}
          color={variant === 'severe' ? 'severe' : active ? 'saas' : undefined}
        >
          {count > 99 ? '99+' : count.toString()}
        </Pill>
      )}
    </div>
  )
}

export default Tab
